// LayoutWrapper.tsx
import useUTMTracker from "./hooks/useUTMTracker";
import StudentLayout from "./components/layout/Layout";

const LayoutWrapper = () => {
  useUTMTracker(); 
  return <StudentLayout />;
};

export default LayoutWrapper;
